<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          <i class="fa fa-wrench mr-5"></i>
          {{'marketplace_settings'|translate}}
        </h3>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>{{'sales_channel_name' | translate}}</th>
                  <th>{{'payment_method' | translate}}</th>
                  <th>{{'delivery_country' | translate}}</th>
                  <th>{{'billing_country' | translate}}</th>
                  <th>{{'sap_cpd_code' | translate}}</th>
                  <th>{{'hkont' | translate}}</th>
                  <th>{{'saknr' | translate}}</th>
                  <th>{{'c4c_customer_id' | translate}}</th>
                  <th>{{'paytype_name' | translate}}</th>
                  <th>{{'paytype' | translate}}</th>
                  <th>{{'billtype_order' | translate}}</th>
                  <th>{{'billtype_return' | translate}}</th>
                  <th>{{'actions' | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="config in this.configs">
                  <td>
                    <template v-if="config.sales_channel_name === 'selfservice_schuhede'">
                      schuhede2.0-parent
                    </template>
                    <template v-else-if="config.sales_channel_name === 'schuhede-selfservice_schuhede'">
                      schuhede2.0
                    </template>
                    <template v-else>
                      {{config.sales_channel_name}}
                    </template>
                  </td>
                  <td>{{config.payment_method}}</td>
                  <td>{{config.delivery_country}}</td>
                  <td>{{config.billing_country}}</td>
                  <td>{{config.sap_cpd_code}}</td>
                  <td>{{config.hkont}}</td>
                  <td>{{config.saknr}}</td>
                  <td>{{config.c4c_customer_id}}</td>
                  <td>{{config.paytype_name}}</td>
                  <td>{{config.paytype}}</td>
                  <td>{{config.billtype_order}}</td>
                  <td>{{config.billtype_return}}</td>
                  <td>
                    <button
                      class="btn btn-flat btn-info mb-10 mt-10"
                      data-toggle="modal"
                      data-target="#sapSalesChannelConfigModal"
                      @click="openSalesChannelConfigModal(config.id)"
                      >
                      <i class="fa fa-wrench mr-5"></i>
                      {{'edit'|translate}}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <button
          class="btn btn-flat btn-info mb-10 mt-10 pull-right"
          data-toggle="modal"
          data-target="#sapSalesChannelConfigModal"
          @click="openNewWindowModal()"
          >
          <i class="fa fa-wrench mr-5"></i>
          {{'new'|translate}}
        </button>
      </div>
    </div>
    <SapSalesChannelConfigModal
      id="sapSalesChannelConfigModal"
      :isNew="openNewWindow"
      :modalSalesChannelConfig="modalSalesChannelConfig"
      >
    </SapSalesChannelConfigModal>
  </section>
</template>

<script>
  export default {
    data() {
      return {
        configs: {},
        modalSalesChannelConfig: {},
        openNewWindow: false
      }
    },
    components: {},
    computed: {},
    methods: {
      openSalesChannelConfigModal(configId) {
        for (var singleConfig in this.configs) {
          if (this.configs[singleConfig].id === configId) {
            this.modalSalesChannelConfig = this.configs[singleConfig];
            this.openNewWindow = false;
          }
        }
      },
      openNewWindowModal() {
        this.modalSalesChannelConfig = {}
        this.openNewWindow = true;
      },
    },
    mounted() {
      API.get('config/sap/saleschannels')
        .then(res => {
          this.configs = res.data
        })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/Sap/SapSalesChannelConf.vue